import { IApplicationState } from '../../types/redux';

export function selectRegionsABC(state: IApplicationState) {
  const { regionInfo } = state;
  const { regionsABC } = regionInfo;

  return regionsABC;
}
